import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link as LinkS } from "react-router-dom";

const Nav = styled.nav`
  padding: 1rem 2rem;
  background: ${({ scrollnav }) =>
    scrollnav
      ? "var(--white)"
      : "linear-gradient(90deg, rgba(0, 0, 0, 0.5) 100%, rgb(0, 0, 0) 100%)"};
  position: sticky;
  top: 0;
  margin-top: -80px;
  z-index: 10;
`;

const NavLink = styled(LinkS)`
  text-decoration: none;
  font-size: 28px;
  font-weight: 600;
  color: ${({ scrollnav }) => (scrollnav ? "var(--black)" : "var(--white)")};
  align-items: center;
  display: flex;
  justify-content: flex-start;
  @media screen and (max-width: 500px) {
    justify-content: center;
  }
`;

export const LogoImg = styled.img`
  width: 8rem;
  height: auto;
  object-fit: cover;
  -o-object-fit: cover;
  z-index: 1;
  margin-left: 3rem;

  @media screen and (max-width: 900px) {
  }
  @media screen and (max-width: 600px) {
  }
  @media screen and (max-width: 500px) {
    margin-left: 0;
  }
`;

const HeroNavbar = () => {
  const [scrollNav, setScrollNav] = useState(false);

  const changeNav = () => {
    if (window.scrollY >= 200) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeNav);
  }, []);

  return (
    <Nav scrollnav={scrollNav ? "true" : undefined}>
      <NavLink to="/" scrollnav={scrollNav ? "true" : undefined}>
        {scrollNav ? (
          <LogoImg src="../PublicImages/TE-Expanded-Logo-Dark.png" alt="logo" />
        ) : (
          <LogoImg
            src="../PublicImages/TE-Expanded-Logo-Light.png"
            alt="logo"
          />
        )}
      </NavLink>
    </Nav>
  );
};

export default HeroNavbar;
